module.exports = __webpack_public_path__ + "static/media/LotteryWeb.13b358d5.webm";